import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=1ab11e0a&scoped=true&"
import script from "./Contacts.vue?vue&type=script&lang=true&"
export * from "./Contacts.vue?vue&type=script&lang=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab11e0a",
  null
  
)

export default component.exports